<script>
export default {
  name: 'cmpt-subscription-feature-abstract',
  props: {
    theme: {
      type: String,
      required: false,
      default: null,
    },
  },
};
</script>

<style lang="scss" scoped>
  $margin: 6px;
  $background-color: #009692;

  .subscription-feature {
    flex-grow: 1;
    display: flex;
    min-height: 1em;
    position: relative;
    flex-direction: column;
    justify-content: center;
    // background-color: $background-color;



    .subscription-feature__main {
      flex-grow: 1;
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: $margin;

      .main__name {
        display: flex;
        z-index: 1;
        margin-left: 1px;
        flex-direction: column;

        > * {
          color: #fff;
          padding: 0 1em;
          font-weight: 500;
          text-shadow: 0 -1px 0 rgba(0, 0, 0, .2);
          span {
            margin-right: 1em;
          }
        }

        a {
          // color: rgba(0, 0, 0, .5);
          color: #fff;
          font-size: 0.7em;
          text-transform: uppercase;
          &:hover {
            color: rgba(#fff, 0.85);
          }
          > i {
            margin-left: 0.5em;
          }
        }
      }

      .subscription-feature__more-less {
        z-index: 0;
        height: 1em;
        flex-grow: 1;
        display: flex;
        overflow: hidden;
        line-height: 1.15;
        text-align: center;
        position: relative;


        &:after {
            position: absolute;
            content: '';
            z-index: 3;
            width: 100%;
            top: 50%;
            height: 0;
            border-top: 1px solid rgba(0, 0, 0, .1);
            border-bottom: 1px solid rgba(255, 255, 255, .2);
        }

      } // end ~ subscription-feature__more-less

      .main__options {
        z-index: 1;
        display: flex;
        flex-shrink: 0;
        padding: 0 0.35em 0 1em;
        margin-right: 1px;
        // background-color: $background-color;

        .main__options__feature--text {
          font-size: 0.85rem;
          color: #e1e1e1;
          font-weight: 500;
          line-height: 32px;
          &:hover {
            cursor: pointer;
          }
        }

        .main__options__feature--label {
          font-size: 1rem;
          color: #fff;
          line-height: 32px;
        }

        /deep/ .el-checkbox-button, /deep/ .el-radio-button {

          .el-checkbox-button__inner,
          .el-radio-button__inner {
            color: #fff;
            border-color: #fff;
            background-color: transparent;
          }

          &:first-child {
            .el-checkbox-button__inner,
            .el-radio-button__inner {
              border-radius: 8px 0 0 8px;
            }
          }

          &:last-child {
            .el-checkbox-button__inner,
            .el-radio-button__inner {
              border-radius: 0 8px 8px 0;
            }
          }

          &:only-child {
            .el-checkbox-button__inner,
            .el-radio-button__inner {
              border-radius: 8px 8px 8px 8px;
            }
          }

          &.is-disabled {
            .el-checkbox-button__inner,
            .el-radio-button__inner {
              border-color: transparent;
              color: #b4bccc;
            }
          }

          &.is-disabled.is-checked, &.is-disabled.is-active {
            .el-checkbox-button__inner,
            .el-radio-button__inner {
              border-radius: 8px;
            }
          }

          &.is-checked, &.is-active {
            .el-checkbox-button__inner,
            .el-radio-button__inner {
              color: #009692;
              font-weight: 600;
              box-shadow: none;
              background-color: #fff;
            }
          }
        }
      }

    } // end ~ subscription-feature__main



    .subscription-feature__more {
      flex-grow: 1;
      display: flex;
      flex-direction: column;

      .more-option-description {
        color: #fff;
        margin: 0.5em 1.25em 0;
        font-size: 0.9em;
        .more-option-description--feature-name {
          font-weight: 600;
        }
      }

      hr {
        margin: 0;
        margin-top: $margin;
      }
    }

    &:first-child {
      border-top-left-radius: 10px;
      border-top-right-radius: 10px;
    }

    &:last-child {
      margin-bottom: $margin;
      border-bottom-left-radius: 10px;
      border-bottom-right-radius: 10px;

      .subscription-feature__more {
        hr { display: none; }
      }
    }

    .without-customization & {
      &:last-child {
        margin-bottom: 0;
        padding-bottom: $margin;
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
      }
    }

    &.theme-gray {
      background-color: #fff;
      .subscription-feature__main {

        .main__name {
          > *, a {
            color: #607d8b;
            text-shadow: none;
          }
        }

        .main__options {
          background-color: #fff;

          .main__options__feature--text {
            color: gray;
          }

          .main__options__feature--label {
            color: gray;
          }

          /deep/ .el-checkbox-button, /deep/ .el-radio-button {

            .el-checkbox-button__inner,
            .el-radio-button__inner {
              color: gray;
              border-color: gray;
              background-color: transparent;
            }
          }

        }
      }
      .subscription-feature__more-less {
        > * {
          a {
            color: rgba(0, 0, 0, .25);
            text-shadow: none;
            &:hover {
              color: rgba(0, 0, 0, .5);
              text-shadow: none;
            }
          }
        }
      }
      .subscription-feature__more {
        .more-option-description {
          color: #607d8b;
        }
      }
    }
    // end ~ theme-gray

    &.theme-global {
      .nuttrema-theme-professional-topography & {
        background-color: rgba(#fff, 0.75);

        .subscription-feature__main {

          .main__name {
            > *, a {
              color: #607d8b;
              text-shadow: none;
            }
          }

          .main__options {
            // background-color: #fff;

            .main__options__feature--text {
              color: gray;
            }

            .main__options__feature--label {
              color: gray;
            }

            /deep/ .el-button-group--nuttrema-radiocheck-group {
              .el-button {
                color: #465568;
                &.is-active {
                  color: #fff;
                  background-color: #465568;
                }
              }
            }

            /deep/ .el-checkbox-button, /deep/ .el-radio-button {
              .el-checkbox-button__inner,
              .el-radio-button__inner {
                color: gray;
                border-color: gray;
                background-color: transparent;
              }
            }

          }
        }

        .subscription-feature__more-less {
          > * {
            a {
              color: rgba(0, 0, 0, .25);
              text-shadow: none;
              &:hover {
                color: rgba(0, 0, 0, .5);
                text-shadow: none;
              }
            }
          }
        }

        .subscription-feature__more {
          .more-option-description {
            color: #607d8b;
          }
        }
      }
    }
    // end ~ theme-global
  }
</style>



// WEBPACK FOOTER //
// src/components/ui/subscription/cmpt-subscription-feature-abstract.vue